import type { CSSProperties } from "react"

/** Subtle radial yellow glow used on the review & commit confirmation screen. */
export const RADIAL_REVIEW_GLOW: CSSProperties = {
  background:
    "radial-gradient(ellipse at 50% 45%, rgba(255,244,64,0.10) 0%, rgba(255,244,64,0.03) 25%, transparent 55%)",
}

/** Stronger radial yellow glow used on the processing / analysis progress screen. */
export const RADIAL_PROCESSING_GLOW: CSSProperties = {
  background:
    "radial-gradient(ellipse at center, rgba(255,244,64,0.18) 0%, rgba(255,244,64,0.04) 40%, transparent 70%)",
}
